import { format } from "date-fns";
import { useTranslation } from "react-i18next";

import { Globe } from "@/components/icons";
import { currentDateFnsLocale } from "@/lib/locale-format";
import type { MySetupSite } from "@/lib/types";
import { uploaderDisplayPath } from "@/lib/uploader-url";

/** Names, date & address — the buyer's page identity, at a glance. */
export function NamesPreviewCard({ site }: { site: MySetupSite }) {
  const { t } = useTranslation();
  const dateLabel = site.weddingDate
    ? format(new Date(`${site.weddingDate}T12:00:00`), "PPP", { locale: currentDateFnsLocale() })
    : t("setup.preview.dateNotSet");

  return (
    <div className="space-y-3 bg-card p-4">
      <div>
        <p className="truncate text-xl font-semibold">{site.displayName}</p>
        <p className="text-sm text-muted-foreground">{dateLabel}</p>
      </div>
      <div className="flex items-center gap-1.5 border-t pt-3 text-sm text-muted-foreground">
        <Globe className="h-3.5 w-3.5 shrink-0" />
        <span className="truncate font-mono">{uploaderDisplayPath(site.slug)}</span>
      </div>
    </div>
  );
}
